import axios from "axios";

const baseUrl = "/AutoConnectSSO/api/Account/LoginGeneration";

const instance = axios.create({
  baseURL: baseUrl,
  withCredentials: true
});

async function GenerateLogin(firstName: string, lastName: string) {
  const url = `/GenerateLogin`;
  const response = await instance.post(url, {
    FirstName: firstName,
    LastName: lastName
  });
  return response.data;
}

export const AccountLoginGenerationService = {
  GenerateLogin
};
